import React 				from 'react';
import ReactDOM 			from 'react-dom';
import ReactJson			from 'react-json-view';
import BLComponent			from '../../../core/_BLComponent.jsx';
import Modal 				from '../../../modals/_DynamicModal.jsx';

import FTUXModalBody		from './_FTUXModalBody.jsx';

export default class FTUXModal extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

		this.state	= 	{
							showModal: true
						};
	}

	componentDidMount() 
	{

	}

	componentWillUnmount() 
	{
		this.setState = (state,callback)=>{
        	return;
    	};
	}

	render() {
		const ftuxModalBody = () => {
			return ( 
			<FTUXModalBody data={this.props.data} func={{toggleModal:()=>this.toggleModal()}}/>
			)
		}

		const modalOption = {
			title: { name: "ddasdf", showClose: true, display: false, clickable: true,  modal_allscreen: false, callback:()=>{this.clickTitle()} }
		,	showCloseButton: false
		,	closeOnEscape: false
		,	modalSize: "l" /* s m l */
		,	ModalBody: ftuxModalBody
		,	modal_allscreen: true
		,	closeFunc: ()=>this.toggleModal()
		}

		return (
			<div>{this.state.showModal&& <Modal data={ modalOption }/> }</div>
		)
	}

	toggleModal() {
		this.props.func.closeTutorialModal();
	}

	clickTitle() {
		return null;
	}

	button()
	{
		return null;
	}

};

